import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiAdRecord, ApiCampaignData } from "../orderAd/orderAd.entity";
import {
  getAdReportThunk,
  getCampaignAdsThunk,
  getPanelAdsThunk,
} from "./ordersList.thunk";
import { GetAdReportResponse } from "./ordersList.api";
import { getClickCountMultiplier } from "utils/utils";

export interface OrdersListStore {
  orders: ApiAdRecord[];
  selectedOrder?: ApiAdRecord;
  campaigns: ApiCampaignData[];
  selectedCampaign?: ApiCampaignData;
  orderReport?: GetAdReportResponse;
}

export const InitialOrdersListState: OrdersListStore = {
  orders: [],
  campaigns: [],
};

const OrdersListSlice = createSlice({
  name: "OrdersListSlice",
  initialState: InitialOrdersListState,
  reducers: {
    setSelectedAd(state, action: PayloadAction<ApiAdRecord | undefined>) {
      state.selectedOrder = action.payload;
      state.orderReport = undefined;
    },
    setSelectedCampaign(
      state,
      action: PayloadAction<ApiCampaignData | undefined>
    ) {
      state.selectedCampaign = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPanelAdsThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.orders = action.payload;
        }
      })
      .addCase(getCampaignAdsThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.campaigns = action.payload;
        }
      })
      .addCase(getAdReportThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.orderReport = action.payload;
        }
      });
  },
});

export const OrdersListActions = OrdersListSlice.actions;
export const OrdersListReducer = OrdersListSlice.reducer;
